export enum ObjectTypeWkf {
  PROCESSUS = 'PROCESSUS',
  TASK = 'TASK',
}
